import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from '@core/pipes/safe-html.pipe';

@Component({
  selector: 'app-text-atom',
  templateUrl: './text-atom.component.html',
  styleUrls: ['./text-atom.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [SafeHtmlPipe],
})
export class TextAtomComponent {
  @Input() content!: unknown;

  forceType(data: any): any {
    return data as any;
  }
}
